import { render, staticRenderFns } from "./OutOfOfficeForm.vue?vue&type=template&id=0829ba87&scoped=true"
import script from "./OutOfOfficeForm.vue?vue&type=script&lang=js"
export * from "./OutOfOfficeForm.vue?vue&type=script&lang=js"
import style0 from "./OutOfOfficeForm.vue?vue&type=style&index=0&id=0829ba87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0829ba87",
  null
  
)

export default component.exports